export const openPositions = [
  {
    id: 1,
    key: 'juniorGenAI',
    department: 'engineering',
    location: 'palestine',
    type: 'fullTime',
    experience: '0-2 years',
    status: 'hired' // 'open' | 'hired'
  }
];
